import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Actions from '../../../../../actions'
import ConfirmationDialog from '../../../../../LEGACY/ConfirmationDialog'
import { ButtonOLD } from '@lmc/ui-kit'
import Glyph from '../../../../../LEGACY/Glyph'

export class ShiftPasswordItem extends Component {
  state = {
    deleteDialogOpen: false,
  }

  toggleDeleteDialog = () => {
    this.setState((prevProps) => ({
      deleteDialogOpen: !prevProps.deleteDialogOpen,
    }))
  }

  handleDeleteConfirm = (id) => {
    this.toggleDeleteDialog()
    this.props.onDelete(id)
  }

  render() {
    const { openModal, shift } = this.props
    if (!shift) return null
    return (
      <li style={styles.container}>
        <div style={styles.entry}>
          <span style={styles.title}>{shift.title}</span>
        </div>
        <div style={styles.entry}>
          <span>
            {shift.startTime} - {shift.endTime}
          </span>
        </div>
        <div style={styles.entry}>
          <span>
            {shift.length} {shift.length === 1 ? 'hour' : 'hours'}
          </span>
        </div>
        <div style={styles.entryActions}>
          <ButtonOLD
            onClick={() => openModal(shift)}
            text="Edit"
            type="secondary"
            icon={<Glyph name="pencil" />}
          >
            Edit
          </ButtonOLD>
          <ButtonOLD
            onClick={this.toggleDeleteDialog}
            style={styles.button}
            type="danger"
          >
            Delete
          </ButtonOLD>
          <ConfirmationDialog
            title="Are you sure?"
            confirmationType="warning"
            isOpen={this.state.deleteDialogOpen}
            onCancel={this.toggleDeleteDialog}
            onConfirmation={() => this.handleDeleteConfirm(shift.id)}
          >
            <div>If you go ahead, it can’t be undone!</div>
          </ConfirmationDialog>
        </div>
      </li>
    )
  }
}

const styles = {
  container: {
    width: '100%',
    minWidth: 290,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 12,
  },
  entry: {
    width: '25%',
    minWidth: 70,
  },
  entryActions: {
    width: '25%',
    minWidth: 70,
    position: 'relative',
    bottom: 5,
    display: 'flex',
  },
  title: {
    fontWeight: 'bold',
  },
  button: { marginLeft: 12 },
}

ShiftPasswordItem.propTypes = {
  shift: PropTypes.object,
  onDelete: PropTypes.func.isRequired,
}

const mapDispatchToProps = (dispatch) => ({
  openModal: (shift) => {
    const id = 'editShift'
    dispatch(Actions.openModal({ modalId: id }))
    dispatch(
      Actions.addForm({
        formId: id,
        initial: {
          id: shift.id,
          title: shift.title,
          startTime: shift.startTime,
          endTime: shift.endTime,
          length: shift.length,
        },
      })
    )
  },
})

export default connect(null, mapDispatchToProps)(ShiftPasswordItem)
